module.exports = __webpack_public_path__ + "assets/img/EISS-Super-eBook.43e46f61.jpg";